import { service_paths } from "@/constants/Services";

export const API_RESPONDENT = {
  class: "this.fetchClassOpts(responseData)",
  term: "this.fetchTermOpts(responseData)",
  grade: "this.fetchGradeOpts(responseData)",
  program: "this.fetchProgramOpts(responseData)",
  student: "this.fetchStudentOpts(responseData)",
  family: "this.fetchFamilyOpts(responseData)",
  teacher: "this.fetchTeacherOpts(responseData)"
};
export const LIST_RESPONDENT = {
  class: "classList",
  term: "termList",
  grade: "gradeList",
  program: "programList",
  student: "studentList",
  family: "parentList",
  teacher: "teacherList"
};

export const PARAMS_API = event => ({
  class: {
    event: event,
    params: { "name__~": event, limit: 20 },
    url: `${service_paths.classes}`
  },
  term: {
    event: event,
    params: { "name__~": event, limit: 20, order_by: "created_at DESC" },
    url: `${service_paths.terms}`
  },
  grade: {
    event: event,
    params: { "name__~": event, limit: 20 },
    url: `${service_paths.grades}`
  },
  program: {
    event: event,
    params: { "name__~": event, limit: 20 },
    url: `${service_paths.programs}`
  },
  student: {
    event: event,
    params: {
      search_key: event,
      fields: ["full_name", "student_code"],
      limit: 20
    },
    url: `${service_paths.students}/filter`
  },
  family: {
    event: event,
    params: { search_key: event, fields: ["full_name", "username"], limit: 20 },
    url: `${service_paths.families}/filter`
  },
  teacher: {
    event: event,
    params: {
      search_key: event,
      fields: ["full_name", "staff_code"],
      limit: 20
    },
    url: `${service_paths.staffs}/filter?role_names=Teacher`
  }
});

export const STUDENT_LIST = [
  {
    id: "all",
    name: "common.all"
  },
  {
    id: "class",
    name: "common.class"
  },
  {
    id: "term",
    name: "common.term"
  },
  {
    id: "grade",
    name: "common.grade"
  },
  {
    id: "program",
    name: "common.program"
  },
  {
    id: "student",
    name: "communication.student_name_student_id"
  }
];
export const FAMILY_LIST = [
  {
    id: "all",
    name: "survey.family_of_student"
  },
  {
    id: "class",
    name: "survey.family_belong_class"
  },
  {
    id: "term",
    name: "survey.family_belong_term"
  },
  {
    id: "grade",
    name: "survey.family_belong_grade"
  },
  {
    id: "program",
    name: "survey.family_belong_program"
  },
  {
    id: "student",
    name: "survey.family_belong_student_name_id"
  },
  {
    id: "family",
    name: "survey.parent_name_username"
  }
];
export const TEACHER_LIST = [
  {
    id: "all",
    name: "common.all"
  },
  {
    id: "class",
    name: "survey.teacher_of_class"
  },
  {
    id: "term",
    name: "survey.teacher_of_class_belong_term"
  },
  {
    id: "teacher",
    name: "survey.teacher_name_staff_id"
  }
];
